import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CreateChatroomPage from '../../../../Containers/CreateChatroomPage';
import { closeChatroom } from '../../../../Redux/ChatListActions';
import type { RootState } from '../../../../Redux';

export const Route = createFileRoute('/(main)/_layout/chats/_chats/new')({
  component: RouteComponent,
});

function RouteComponent() {
  const dispatch = useDispatch();
  const { activeChatId } = useSelector((state: RootState) => state.chatList);

  // Close the active chatroom
  useEffect(() => {
    if (activeChatId) {
      dispatch(closeChatroom(activeChatId));
    }
  }, [activeChatId, dispatch]);

  return <CreateChatroomPage />;
}
